import { API, authClient } from "../index";

// Get all cotizaciones
export const getCotizaciones = () => {
  return authClient().get(`${API}/cotizacion?getDisabled=true`);
};

// Get cotizacion by id
export const getCotizacionById = (id) => {
  return authClient().get(`${API}/cotizacion/${id}`);
};

// Delete cotizacion
export const deleteCotizacion = (id) => {
  return authClient().delete(`${API}/cotizacion/${id}`);
};

// Create cotizacion
export const postCotizacion = async (cotizacion) => {
  return authClient().post(`${API}/cotizacion`, cotizacion);
};

// Update cotizacion
export const updateCotizacion = async (id, cotizacion) => {
  return authClient().put(`${API}/cotizacion/${id}`, cotizacion);
};

// Change status cotizacion
export const changeStatusCotizacion = async (id, active) => {
  return authClient().put(`${API}/cotizacion/change-status/${id}`, { active });
};
